<template>
  <el-dialog title="添加作者" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" class="dialogEdit">
    <el-form :model="form">
      <el-form-item label="作者名稱" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off">
          <template slot="prepend">繁</template>
        </el-input>
        
        <el-input v-model="form.name_cn" autocomplete="off">
          <template slot="prepend">簡</template>
        </el-input>

        <el-input v-model="form.name_en" autocomplete="off">
          <template slot="prepend">英</template>
        </el-input>
      </el-form-item>
      <el-form-item label="作者簡介" :label-width="formLabelWidth">
        <el-input v-model="form.brief" autocomplete="off">
          <template slot="prepend">繁</template>
        </el-input>
        
        <el-input v-model="form.brief_cn" autocomplete="off">
          <template slot="prepend">簡</template>
        </el-input>

        <el-input v-model="form.brief_en" autocomplete="off">
          <template slot="prepend">英</template>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "author_dialog",
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: 30,
      form: {
        name: "",
        name_cn: "",
        name_en: "",
        brief: "",
        brief_cn: "",
        brief_en: "",
      }
    };
  },
  methods: {
    show(value) {
      this.dialogVisible = true;
      if (value !== undefined) {
        this.form = Object.assign({}, value);
      } else {
        this.form = {
                      name: "",
                      name_cn: "",
                      name_en: "",
                      brief: "",
                      brief_cn: "",
                      brief_en: "",
                    };
      }
    },
    onSubmit() {
      var self = this;
      let params = Object.assign({}, this.form);
      this.$http.post("/admin/author/edit", params).then(res => {
        self.$emit("sucess");
        this.dialogVisible = false;
      });
    }
  }
};
</script>
<style lang="less">
.dialogEdit{
    text-align:left;
    
}
</style>